// extracted by mini-css-extract-plugin
export default {"wrapper__auth":"AuthPage_wrapper__auth__I9OX9","title":"AuthPage_title__OKiw-","auth__page":"AuthPage_auth__page__gkMak","auth__page__select":"AuthPage_auth__page__select__znZ9K"};